import { postData } from '../../../services/http';
import { toDict } from '../../../services/arrayUtils';

/**
 * An Interface which describes the teaser price api response data.
 */
export interface IApiProductsResponseItem {
    ErrorMessage: string;
    Request: {
        Id: string,
        DomainId: number,
        Currency: string,
        Tags: any
    };
    Prices: {
        Price: number,
        Currency: string,
        Type: string
    }[];
}
export type ProductsDict = { [key: string]: IApiProductsResponseItem };

const url = '/api2/attractions/bookingfunnel/getteaserprices';

export function getTeaserPrices(productType: string, productIds: any) {
    /// TODO add other product endpoints, for now only attractions are available
    if ('attraction' === productType) {
        return postData<IApiProductsResponseItem[]>(url, productIds, { logErrors: false })
            .then(transformTeaserPriceResponse);
    }
}

/**
 * Transform the response objects in a form which will be easier to handle on the frontend. Response array is
 * transformed into a dictionary, where each key is a product id, data on each key is product data. Prices array
 * for each item is ordered in a specific way, depending on the product type.
 */
function transformTeaserPriceResponse(data?: IApiProductsResponseItem[]): ProductsDict | void {
    if (!data) {
        return;
    }

    const pricesOrder = ['adult', 'child'];
    const items = data.filter(item => !!(item.Request && item.Request.Id));

    function keyFn(item: IApiProductsResponseItem) {
        const tags = item.Request.Tags || {};
        let tagKey = '';
        for (const i in tags) {
            if (tags.hasOwnProperty(i)) {
                tagKey += `:${i}:${tags[i]}`;
            }
        }
        return `${item.Request.Id}${tagKey}`;
    }

    function valFn(item:IApiProductsResponseItem) {
        item.Prices.sort(function(a, b) {
            const indexA = pricesOrder.indexOf(a.Type.toLocaleLowerCase());
            const indexB = pricesOrder.indexOf(b.Type.toLocaleLowerCase());
            if (indexA < indexB || (-1 === indexB && -1 !== indexA)) {
                return -1;
            }
            if (indexB < indexA || (-1 === indexA && -1 !== indexB)) {
                return 1;
            }
            return 0;
        });
        return item;
    }

    return toDict<IApiProductsResponseItem>(items, keyFn, valFn);
}
